import { gql } from "@apollo/client";export default gql`mutation AddTag($object: tag_insert_input!){
  insert_tag_one(object: $object) {
    id
    name
    value
    group
  }
}
`;
